export default "__VITE_PUBLIC_ASSET__58c9105f__"